var AdaptiveImage = require("../../../node_modules/react-native-web-image-loader/lib/modules/adaptiveImage.js").default;

module.exports = new AdaptiveImage({
    uri: __webpack_public_path__ + "static/media/my_address.5ebc3fd3.png","uri@2x": __webpack_public_path__ + "static/media/my_address.7dac87c0.png","uri@3x": __webpack_public_path__ + "static/media/my_address.7ea784a8.png",
    width: 42,
    height: 42
});